// extracted by mini-css-extract-plugin
export default {"aboutImage":"About_aboutImage__Y9izp"};